module.exports = __webpack_public_path__ + "img/check_box.544861db.svg";